export default __webpack_public_path__ + "static/media/modal_change_training.442da442.png";